import {
  ResultEnum,
  TransformExecuteResponse
} from "../types/clientTypes";
import {
  StatusCode
} from "../types/sharedTypes";
import {
  TestCase,
  TestCaseTemplate
} from "../types/testCaseTemplateTypes";
import {
  getTransformTestCase,
  getTransformTestCaseByExecuteResult
} from "./testCaseUtils";
import { SelectedVariable } from "../types/variableType";
import { customParse } from "./getStringJson";

export const getExecuteResult = (selectedVariables: Array<SelectedVariable>, executeResponse: TransformExecuteResponse, testCaseTemplate: TestCaseTemplate, testCase: TestCase, statusCodes: StatusCode[]): ResultEnum | undefined => {
  if (executeResponse.isValid != null && !executeResponse.isValid) {
    return ResultEnum.failed;
  }

  if (executeResponse.statusCode === -1) {
    return ResultEnum.skipped;
  }

  if (executeResponse.isError) {
    return ResultEnum.serverError;
  }

  let transformTestCase = getTransformTestCase(selectedVariables, testCaseTemplate, testCase);
  if (!!executeResponse.statusCode) {
    transformTestCase = getTransformTestCaseByExecuteResult(selectedVariables, transformTestCase, executeResponse);
  }
  const responseStatusCode = statusCodes.find(item => item.code === executeResponse.statusCode);
  let expectedBody;
  let skipComparison = !!executeResponse.isValid;
  if (!skipComparison && transformTestCase.expectedBody) {
    try {
      expectedBody = customParse(transformTestCase.expectedBody)
    } catch (e) {
      expectedBody = transformTestCase.expectedBody;
    }
  }
  let responseBody;
  if (!skipComparison && executeResponse.responseBody) {
    try {
      responseBody = customParse(executeResponse.responseBody);
    } catch (e) {
      responseBody = executeResponse.responseBody;
    }
  }
  if (!!responseStatusCode) {
    if (responseStatusCode.id === testCaseTemplate.statusCodeId) {
      if ((skipComparison || deepEqual(expectedBody, responseBody))) {
        if (testCaseTemplate.maximumExecutionTimeout * 1000 > executeResponse.time) {
          return ResultEnum.passed;
        } else {
          return ResultEnum.passedExecutionTime;
        }
      } else {
        return ResultEnum.failed;
      }
    } else {
      return ResultEnum.failed;
    }
  } else {
    return undefined;
  }
}

export const getTestrailStatusId = (executeResponse: TransformExecuteResponse): number => {
  let statusId: number;
  switch (executeResponse.result) {
    case ResultEnum.passed: {
      statusId = 1
      break;
    }
    case ResultEnum.passedExecutionTime: {
      statusId = 6
      break;
    }
    case ResultEnum.failed:
    case ResultEnum.serverError:
    default: {
      statusId = 5;
      break;
    }
  }
  return statusId;
}

export const getTestrailComment = (statusId: number, executeResponse: TransformExecuteResponse): string => {
  switch (statusId) {
    case 1: {
      return `Passed ${executeResponse.time}ms`;
    }
    case 5: {
      return `${executeResponse.responseBody} ${executeResponse.time}ms`;
    }
    case 6: {
      return `Passed - Execution time exceeded ${executeResponse.time}ms`;
    }
    default: {
      return "";
    }
  }
}

const deepEqual = (obj1: any, obj2: any): boolean => {
  if (obj1 === obj2) {
    return true;
  }

  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (!keys2.includes(key)) {
      return false;
    }
  }

  for (const key of keys1) {
    if (!deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
